







import Vue from 'vue'

import { Component, Prop, Emit } from 'vue-property-decorator'
import SceneDialog from './SceneDialog.vue'
import { CheckboxModel } from '../interfaces/checkbox-model'
import { PolicyReportRule } from '../interfaces/report-rule'

@Component({
  components: {
    SceneDialog
  }
})
export default class FilterSetting extends Vue {
  @Prop({ type: Object as () => CheckboxModel }) readonly items!: CheckboxModel
  @Prop({ type: Array as () => PolicyReportRule[] }) readonly rules!: PolicyReportRule[]

  show = false;

  isShowDialog = false

  onClick () {
    this.isShowDialog = true
  }

  handleHide () {
    this.isShowDialog = false
  }

  handleCancel () {
    this.handleHide()
  }

  @Emit('refresh')
  handleRefresh () {}
}
